import React from "react";

import EmptyImage from "assets/svg/emptyImage.svg";

import styled from "styled-components";

const EmptyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 8px;

  img {
    width: 200px;
    height: 200px;
    object-fit: cover;
  }

  p {
    color: var(--Neutral-60);
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.018px;
  }
`;

const EmptyData = ({ hasData = false, message = "No Data Yet!" }) => {
  if (hasData) return null;
  return (
    <EmptyWrapper>
      <img src={EmptyImage} alt="empty-image" />
      <p>{message}</p>
    </EmptyWrapper>
  );
};

export default EmptyData;
